import { createFileRoute } from '@tanstack/react-router';

import { getArticleOptions } from '@/module/Author/Article';

export const Route = createFileRoute('/_auth/author/_author/article/_article/$articleId/_layout')({
  loader: async ({ params: { articleId }, context: { queryClient } }) => {
    const article = await queryClient.ensureQueryData(getArticleOptions(articleId));

    return {
      article,
      crumb: article.title,
    };
  },
});
